export default __webpack_public_path__ + "static/image7-97342454e6a2907cc16d7990ea95824a.jpg";